module.exports = __webpack_public_path__ + "img/newsletter-1-dark.73147c5d.svg";